import gql from 'graphql-tag';

export const uploadPhysicianSignature = gql`
  mutation uploadMySignature($signature: String!) {
    uploadMySignature(signature: $signature)
  }
`;
